import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { sharedApi } from "../../services/sharedApi";
import { toApiError } from "../../types/api";

import type { RegistrationSettings } from "@lingoshade/domain";

export const fetchRegistrationSettings = createAsyncThunk<
  RegistrationSettings,
  void,
  { rejectValue: string }
>(
  "registration/fetch",
  async (
    _,
    { rejectWithValue },
  ): Promise<RegistrationSettings | ReturnType<typeof rejectWithValue>> => {
    try {
      return await sharedApi.auth.getRegistrationSettings();
    } catch (error: unknown) {
      return rejectWithValue(toApiError(error).message);
    }
  },
);

const registrationSlice = createSlice({
  name: "registration",
  initialState: { registrationEnabled: false, loaded: false },
  reducers: {},
  extraReducers: (builder): void => {
    builder
      .addCase(fetchRegistrationSettings.fulfilled, (state, action): void => {
        state.registrationEnabled = action.payload.registrationEnabled;
        state.loaded = true;
      })
      .addCase(fetchRegistrationSettings.rejected, (state): void => {
        state.registrationEnabled = false;
        state.loaded = false;
      });
  },
});

export default registrationSlice.reducer;
